export class AddressInfo {
    id: number | undefined;
    mapboxId: string | undefined;
    statusId: number | undefined;
    verified: boolean | undefined;
    countryName: string | undefined;
    countryCode: string | undefined;
    countryCodeAlpha3: string | undefined;
    regionName: string | undefined;
    regionCode: string | undefined;
    postcode: string | undefined;
    place: string | undefined;
    streetName: string | undefined;
    addressNumber: string | undefined;
    longitude: number | undefined;
    latitude: number | undefined;
    dateStart: Date | undefined;
    dateLast: Date | undefined;
    dateEnd: Date | undefined;
}

export enum EnumAddressStatus {
    approval = 18,
    active = 19,
    refused = 20,
    inactive = 21,
    suspended = 22,
    banned = 23,
    erased = 24,
    closed = 25
}
